/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as SettingsRouteRouteImport } from './routes/_settings/route'
import { Route as AppRouteRouteImport } from './routes/_app/route'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AuthCallbackRouteImport } from './routes/auth/callback'
import { Route as AppSpeedToLeadRouteRouteImport } from './routes/_app/speed-to-lead/route'
import { Route as AppCallCenterRouteRouteImport } from './routes/_app/call-center/route'
import { Route as SettingsSettingsIndexRouteImport } from './routes/_settings/settings/index'
import { Route as AppSpeedToLeadIndexRouteImport } from './routes/_app/speed-to-lead/index'
import { Route as AppCallCenterIndexRouteImport } from './routes/_app/call-center/index'
import { Route as AppSpeedToLeadReportsRouteImport } from './routes/_app/speed-to-lead/reports'
import { Route as AppSpeedToLeadPipelineRouteImport } from './routes/_app/speed-to-lead/pipeline'
import { Route as AppSpeedToLeadLeadsRouteImport } from './routes/_app/speed-to-lead/leads'
import { Route as AppCallCenterScorecardsRouteImport } from './routes/_app/call-center/scorecards'
import { Route as AppCallCenterMonitoringRouteImport } from './routes/_app/call-center/monitoring'
import { Route as AppCallCenterCallListRouteImport } from './routes/_app/call-center/call-list'
import { Route as AppSpeedToLeadCampaignsRouteRouteImport } from './routes/_app/speed-to-lead/campaigns/route'
import { Route as AppSpeedToLeadCampaignsIndexRouteImport } from './routes/_app/speed-to-lead/campaigns/index'
import { Route as AppSpeedToLeadCampaignsIdRouteImport } from './routes/_app/speed-to-lead/campaigns/$id'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRouteRoute = SettingsRouteRouteImport.update({
  id: '/_settings',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRouteRoute = AppRouteRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AppSpeedToLeadRouteRoute = AppSpeedToLeadRouteRouteImport.update({
  id: '/speed-to-lead',
  path: '/speed-to-lead',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppCallCenterRouteRoute = AppCallCenterRouteRouteImport.update({
  id: '/call-center',
  path: '/call-center',
  getParentRoute: () => AppRouteRoute,
} as any)
const SettingsSettingsIndexRoute = SettingsSettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const AppSpeedToLeadIndexRoute = AppSpeedToLeadIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSpeedToLeadRouteRoute,
} as any)
const AppCallCenterIndexRoute = AppCallCenterIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppCallCenterRouteRoute,
} as any)
const AppSpeedToLeadReportsRoute = AppSpeedToLeadReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AppSpeedToLeadRouteRoute,
} as any)
const AppSpeedToLeadPipelineRoute = AppSpeedToLeadPipelineRouteImport.update({
  id: '/pipeline',
  path: '/pipeline',
  getParentRoute: () => AppSpeedToLeadRouteRoute,
} as any)
const AppSpeedToLeadLeadsRoute = AppSpeedToLeadLeadsRouteImport.update({
  id: '/leads',
  path: '/leads',
  getParentRoute: () => AppSpeedToLeadRouteRoute,
} as any)
const AppCallCenterScorecardsRoute = AppCallCenterScorecardsRouteImport.update({
  id: '/scorecards',
  path: '/scorecards',
  getParentRoute: () => AppCallCenterRouteRoute,
} as any)
const AppCallCenterMonitoringRoute = AppCallCenterMonitoringRouteImport.update({
  id: '/monitoring',
  path: '/monitoring',
  getParentRoute: () => AppCallCenterRouteRoute,
} as any)
const AppCallCenterCallListRoute = AppCallCenterCallListRouteImport.update({
  id: '/call-list',
  path: '/call-list',
  getParentRoute: () => AppCallCenterRouteRoute,
} as any)
const AppSpeedToLeadCampaignsRouteRoute =
  AppSpeedToLeadCampaignsRouteRouteImport.update({
    id: '/campaigns',
    path: '/campaigns',
    getParentRoute: () => AppSpeedToLeadRouteRoute,
  } as any)
const AppSpeedToLeadCampaignsIndexRoute =
  AppSpeedToLeadCampaignsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppSpeedToLeadCampaignsRouteRoute,
  } as any)
const AppSpeedToLeadCampaignsIdRoute =
  AppSpeedToLeadCampaignsIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AppSpeedToLeadCampaignsRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/login': typeof LoginRoute
  '/call-center': typeof AppCallCenterRouteRouteWithChildren
  '/speed-to-lead': typeof AppSpeedToLeadRouteRouteWithChildren
  '/auth/callback': typeof AuthCallbackRoute
  '/speed-to-lead/campaigns': typeof AppSpeedToLeadCampaignsRouteRouteWithChildren
  '/call-center/call-list': typeof AppCallCenterCallListRoute
  '/call-center/monitoring': typeof AppCallCenterMonitoringRoute
  '/call-center/scorecards': typeof AppCallCenterScorecardsRoute
  '/speed-to-lead/leads': typeof AppSpeedToLeadLeadsRoute
  '/speed-to-lead/pipeline': typeof AppSpeedToLeadPipelineRoute
  '/speed-to-lead/reports': typeof AppSpeedToLeadReportsRoute
  '/call-center/': typeof AppCallCenterIndexRoute
  '/speed-to-lead/': typeof AppSpeedToLeadIndexRoute
  '/settings/': typeof SettingsSettingsIndexRoute
  '/speed-to-lead/campaigns/$id': typeof AppSpeedToLeadCampaignsIdRoute
  '/speed-to-lead/campaigns/': typeof AppSpeedToLeadCampaignsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof AppIndexRoute
  '/login': typeof LoginRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/call-center/call-list': typeof AppCallCenterCallListRoute
  '/call-center/monitoring': typeof AppCallCenterMonitoringRoute
  '/call-center/scorecards': typeof AppCallCenterScorecardsRoute
  '/speed-to-lead/leads': typeof AppSpeedToLeadLeadsRoute
  '/speed-to-lead/pipeline': typeof AppSpeedToLeadPipelineRoute
  '/speed-to-lead/reports': typeof AppSpeedToLeadReportsRoute
  '/call-center': typeof AppCallCenterIndexRoute
  '/speed-to-lead': typeof AppSpeedToLeadIndexRoute
  '/settings': typeof SettingsSettingsIndexRoute
  '/speed-to-lead/campaigns/$id': typeof AppSpeedToLeadCampaignsIdRoute
  '/speed-to-lead/campaigns': typeof AppSpeedToLeadCampaignsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteRouteWithChildren
  '/_settings': typeof SettingsRouteRouteWithChildren
  '/login': typeof LoginRoute
  '/_app/call-center': typeof AppCallCenterRouteRouteWithChildren
  '/_app/speed-to-lead': typeof AppSpeedToLeadRouteRouteWithChildren
  '/auth/callback': typeof AuthCallbackRoute
  '/_app/': typeof AppIndexRoute
  '/_app/speed-to-lead/campaigns': typeof AppSpeedToLeadCampaignsRouteRouteWithChildren
  '/_app/call-center/call-list': typeof AppCallCenterCallListRoute
  '/_app/call-center/monitoring': typeof AppCallCenterMonitoringRoute
  '/_app/call-center/scorecards': typeof AppCallCenterScorecardsRoute
  '/_app/speed-to-lead/leads': typeof AppSpeedToLeadLeadsRoute
  '/_app/speed-to-lead/pipeline': typeof AppSpeedToLeadPipelineRoute
  '/_app/speed-to-lead/reports': typeof AppSpeedToLeadReportsRoute
  '/_app/call-center/': typeof AppCallCenterIndexRoute
  '/_app/speed-to-lead/': typeof AppSpeedToLeadIndexRoute
  '/_settings/settings/': typeof SettingsSettingsIndexRoute
  '/_app/speed-to-lead/campaigns/$id': typeof AppSpeedToLeadCampaignsIdRoute
  '/_app/speed-to-lead/campaigns/': typeof AppSpeedToLeadCampaignsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/call-center'
    | '/speed-to-lead'
    | '/auth/callback'
    | '/speed-to-lead/campaigns'
    | '/call-center/call-list'
    | '/call-center/monitoring'
    | '/call-center/scorecards'
    | '/speed-to-lead/leads'
    | '/speed-to-lead/pipeline'
    | '/speed-to-lead/reports'
    | '/call-center/'
    | '/speed-to-lead/'
    | '/settings/'
    | '/speed-to-lead/campaigns/$id'
    | '/speed-to-lead/campaigns/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/auth/callback'
    | '/call-center/call-list'
    | '/call-center/monitoring'
    | '/call-center/scorecards'
    | '/speed-to-lead/leads'
    | '/speed-to-lead/pipeline'
    | '/speed-to-lead/reports'
    | '/call-center'
    | '/speed-to-lead'
    | '/settings'
    | '/speed-to-lead/campaigns/$id'
    | '/speed-to-lead/campaigns'
  id:
    | '__root__'
    | '/_app'
    | '/_settings'
    | '/login'
    | '/_app/call-center'
    | '/_app/speed-to-lead'
    | '/auth/callback'
    | '/_app/'
    | '/_app/speed-to-lead/campaigns'
    | '/_app/call-center/call-list'
    | '/_app/call-center/monitoring'
    | '/_app/call-center/scorecards'
    | '/_app/speed-to-lead/leads'
    | '/_app/speed-to-lead/pipeline'
    | '/_app/speed-to-lead/reports'
    | '/_app/call-center/'
    | '/_app/speed-to-lead/'
    | '/_settings/settings/'
    | '/_app/speed-to-lead/campaigns/$id'
    | '/_app/speed-to-lead/campaigns/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRouteRoute: typeof AppRouteRouteWithChildren
  SettingsRouteRoute: typeof SettingsRouteRouteWithChildren
  LoginRoute: typeof LoginRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_settings': {
      id: '/_settings'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof SettingsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/speed-to-lead': {
      id: '/_app/speed-to-lead'
      path: '/speed-to-lead'
      fullPath: '/speed-to-lead'
      preLoaderRoute: typeof AppSpeedToLeadRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/call-center': {
      id: '/_app/call-center'
      path: '/call-center'
      fullPath: '/call-center'
      preLoaderRoute: typeof AppCallCenterRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_settings/settings/': {
      id: '/_settings/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof SettingsSettingsIndexRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/_app/speed-to-lead/': {
      id: '/_app/speed-to-lead/'
      path: '/'
      fullPath: '/speed-to-lead/'
      preLoaderRoute: typeof AppSpeedToLeadIndexRouteImport
      parentRoute: typeof AppSpeedToLeadRouteRoute
    }
    '/_app/call-center/': {
      id: '/_app/call-center/'
      path: '/'
      fullPath: '/call-center/'
      preLoaderRoute: typeof AppCallCenterIndexRouteImport
      parentRoute: typeof AppCallCenterRouteRoute
    }
    '/_app/speed-to-lead/reports': {
      id: '/_app/speed-to-lead/reports'
      path: '/reports'
      fullPath: '/speed-to-lead/reports'
      preLoaderRoute: typeof AppSpeedToLeadReportsRouteImport
      parentRoute: typeof AppSpeedToLeadRouteRoute
    }
    '/_app/speed-to-lead/pipeline': {
      id: '/_app/speed-to-lead/pipeline'
      path: '/pipeline'
      fullPath: '/speed-to-lead/pipeline'
      preLoaderRoute: typeof AppSpeedToLeadPipelineRouteImport
      parentRoute: typeof AppSpeedToLeadRouteRoute
    }
    '/_app/speed-to-lead/leads': {
      id: '/_app/speed-to-lead/leads'
      path: '/leads'
      fullPath: '/speed-to-lead/leads'
      preLoaderRoute: typeof AppSpeedToLeadLeadsRouteImport
      parentRoute: typeof AppSpeedToLeadRouteRoute
    }
    '/_app/call-center/scorecards': {
      id: '/_app/call-center/scorecards'
      path: '/scorecards'
      fullPath: '/call-center/scorecards'
      preLoaderRoute: typeof AppCallCenterScorecardsRouteImport
      parentRoute: typeof AppCallCenterRouteRoute
    }
    '/_app/call-center/monitoring': {
      id: '/_app/call-center/monitoring'
      path: '/monitoring'
      fullPath: '/call-center/monitoring'
      preLoaderRoute: typeof AppCallCenterMonitoringRouteImport
      parentRoute: typeof AppCallCenterRouteRoute
    }
    '/_app/call-center/call-list': {
      id: '/_app/call-center/call-list'
      path: '/call-list'
      fullPath: '/call-center/call-list'
      preLoaderRoute: typeof AppCallCenterCallListRouteImport
      parentRoute: typeof AppCallCenterRouteRoute
    }
    '/_app/speed-to-lead/campaigns': {
      id: '/_app/speed-to-lead/campaigns'
      path: '/campaigns'
      fullPath: '/speed-to-lead/campaigns'
      preLoaderRoute: typeof AppSpeedToLeadCampaignsRouteRouteImport
      parentRoute: typeof AppSpeedToLeadRouteRoute
    }
    '/_app/speed-to-lead/campaigns/': {
      id: '/_app/speed-to-lead/campaigns/'
      path: '/'
      fullPath: '/speed-to-lead/campaigns/'
      preLoaderRoute: typeof AppSpeedToLeadCampaignsIndexRouteImport
      parentRoute: typeof AppSpeedToLeadCampaignsRouteRoute
    }
    '/_app/speed-to-lead/campaigns/$id': {
      id: '/_app/speed-to-lead/campaigns/$id'
      path: '/$id'
      fullPath: '/speed-to-lead/campaigns/$id'
      preLoaderRoute: typeof AppSpeedToLeadCampaignsIdRouteImport
      parentRoute: typeof AppSpeedToLeadCampaignsRouteRoute
    }
  }
}

interface AppCallCenterRouteRouteChildren {
  AppCallCenterCallListRoute: typeof AppCallCenterCallListRoute
  AppCallCenterMonitoringRoute: typeof AppCallCenterMonitoringRoute
  AppCallCenterScorecardsRoute: typeof AppCallCenterScorecardsRoute
  AppCallCenterIndexRoute: typeof AppCallCenterIndexRoute
}

const AppCallCenterRouteRouteChildren: AppCallCenterRouteRouteChildren = {
  AppCallCenterCallListRoute: AppCallCenterCallListRoute,
  AppCallCenterMonitoringRoute: AppCallCenterMonitoringRoute,
  AppCallCenterScorecardsRoute: AppCallCenterScorecardsRoute,
  AppCallCenterIndexRoute: AppCallCenterIndexRoute,
}

const AppCallCenterRouteRouteWithChildren =
  AppCallCenterRouteRoute._addFileChildren(AppCallCenterRouteRouteChildren)

interface AppSpeedToLeadCampaignsRouteRouteChildren {
  AppSpeedToLeadCampaignsIdRoute: typeof AppSpeedToLeadCampaignsIdRoute
  AppSpeedToLeadCampaignsIndexRoute: typeof AppSpeedToLeadCampaignsIndexRoute
}

const AppSpeedToLeadCampaignsRouteRouteChildren: AppSpeedToLeadCampaignsRouteRouteChildren =
  {
    AppSpeedToLeadCampaignsIdRoute: AppSpeedToLeadCampaignsIdRoute,
    AppSpeedToLeadCampaignsIndexRoute: AppSpeedToLeadCampaignsIndexRoute,
  }

const AppSpeedToLeadCampaignsRouteRouteWithChildren =
  AppSpeedToLeadCampaignsRouteRoute._addFileChildren(
    AppSpeedToLeadCampaignsRouteRouteChildren,
  )

interface AppSpeedToLeadRouteRouteChildren {
  AppSpeedToLeadCampaignsRouteRoute: typeof AppSpeedToLeadCampaignsRouteRouteWithChildren
  AppSpeedToLeadLeadsRoute: typeof AppSpeedToLeadLeadsRoute
  AppSpeedToLeadPipelineRoute: typeof AppSpeedToLeadPipelineRoute
  AppSpeedToLeadReportsRoute: typeof AppSpeedToLeadReportsRoute
  AppSpeedToLeadIndexRoute: typeof AppSpeedToLeadIndexRoute
}

const AppSpeedToLeadRouteRouteChildren: AppSpeedToLeadRouteRouteChildren = {
  AppSpeedToLeadCampaignsRouteRoute:
    AppSpeedToLeadCampaignsRouteRouteWithChildren,
  AppSpeedToLeadLeadsRoute: AppSpeedToLeadLeadsRoute,
  AppSpeedToLeadPipelineRoute: AppSpeedToLeadPipelineRoute,
  AppSpeedToLeadReportsRoute: AppSpeedToLeadReportsRoute,
  AppSpeedToLeadIndexRoute: AppSpeedToLeadIndexRoute,
}

const AppSpeedToLeadRouteRouteWithChildren =
  AppSpeedToLeadRouteRoute._addFileChildren(AppSpeedToLeadRouteRouteChildren)

interface AppRouteRouteChildren {
  AppCallCenterRouteRoute: typeof AppCallCenterRouteRouteWithChildren
  AppSpeedToLeadRouteRoute: typeof AppSpeedToLeadRouteRouteWithChildren
  AppIndexRoute: typeof AppIndexRoute
}

const AppRouteRouteChildren: AppRouteRouteChildren = {
  AppCallCenterRouteRoute: AppCallCenterRouteRouteWithChildren,
  AppSpeedToLeadRouteRoute: AppSpeedToLeadRouteRouteWithChildren,
  AppIndexRoute: AppIndexRoute,
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(
  AppRouteRouteChildren,
)

interface SettingsRouteRouteChildren {
  SettingsSettingsIndexRoute: typeof SettingsSettingsIndexRoute
}

const SettingsRouteRouteChildren: SettingsRouteRouteChildren = {
  SettingsSettingsIndexRoute: SettingsSettingsIndexRoute,
}

const SettingsRouteRouteWithChildren = SettingsRouteRoute._addFileChildren(
  SettingsRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AppRouteRoute: AppRouteRouteWithChildren,
  SettingsRouteRoute: SettingsRouteRouteWithChildren,
  LoginRoute: LoginRoute,
  AuthCallbackRoute: AuthCallbackRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
